import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";

// Validación con yup
const expenseSchema = yup.object().shape({
    category: yup.string().required("Categoría requerida"),
    fee_type: yup.string().required("Tipo de gasto requerido"),
    payment_type: yup.string().required("Método de pago requerido"),
    amount: yup.number().required("Monto requerido").positive(),
    fee_description: yup.string(),
    fee_date: yup.string().required("Fecha requerida")
});

const ExpenseEditDialog = ({
    open,
    onClose,
    item,
    onSave,
    categories = [],
    feeTypes = [],
    paymentTypes = [],
    date,
}) => {

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            // Ejecutar función para guardar cambios
            await onSave(values);
            onClose();
        } catch (err) {
            console.error("Error al actualizar gasto:", err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Editar Gasto</DialogTitle>
            <Formik
                initialValues={{
                    id: item?.id,
                    category: item?.category || "",
                    fee_type: item?.fee_type || "",
                    payment_type: item?.payment_type || "",
                    amount: item?.amount || "",
                    fee_description: item?.fee_description || "",
                    fee_date: date || "" // formato yyyy-mm-dd
                }}
                validationSchema={expenseSchema}
                onSubmit={handleSubmit}
                
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    touched,
                    errors,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent sx={{ display: "grid", gap: 2 }}>
                            {/* Fecha */}
                            <TextField
                                fullWidth
                                variant="outlined"
                                type="date"
                                label="Fecha"
                                name="fee_date"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.fee_date}
                                error={!!touched.fee_date && !!errors.fee_date}
                                helperText={touched.fee_date && errors.fee_date}
                            />

                            {/* Categoría */}
                            <FormControl fullWidth>
                                <InputLabel>Categoría</InputLabel>
                                <Select
                                    name="category"
                                    value={values.category}
                                    onChange={(e) => {
                                        const newCategory = e.target.value;
                                        setFieldValue('category', newCategory);   // Actualiza la categoría
                                        setFieldValue('fee_type', '');            // Limpia fee_type
                                    }}
                                    onBlur={handleBlur}
                                    label="Categoría"
                                    error={!!touched.category && !!errors.category}
                                >
                                    {categories.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Tipo de gasto */}
                            <FormControl fullWidth>
                                <InputLabel>Tipo de gasto</InputLabel>
                                <Select
                                    name="fee_type"
                                    value={values.fee_type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Tipo de gasto"
                                    error={!!touched.fee_type && !!errors.fee_type}
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una opción</em>
                                    </MenuItem>
                                    {(feeTypes[values.category] || []).map((type) => (
                                        <MenuItem key={type.id} value={type.id}>
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Método de pago */}
                            <FormControl fullWidth>
                                <InputLabel>Método de pago</InputLabel>
                                <Select
                                    name="payment_type"
                                    value={values.payment_type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Método de pago"
                                    error={!!touched.payment_type && !!errors.payment_type}
                                >
                                    {paymentTypes.map((type) => (
                                        <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Monto */}
                            <TextField
                                fullWidth
                                label="Monto (USD)"
                                name="amount"
                                type="number"
                                value={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.amount && !!errors.amount}
                                helperText={touched.amount && errors.amount}
                            />

                            {/* Descripción */}
                            <TextField
                                fullWidth
                                label="Descripción"
                                name="fee_description"
                                value={values.fee_description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={onClose} color="inherit">
                                Cancelar
                            </Button>
                            <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                                Actualizar
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ExpenseEditDialog;
